import React, { useContext } from 'react';

import styled from 'styled-components';

import AttendanceError from './AttendanceError';
import AttendanceLoading from './AttendanceLoading';
import AttendanceOverview from './AttendanceOverview';
import AttendanceProgress from './AttendanceProgress';
import AttendanceSelect from './AttendanceSelect';
import NoSessionsAttendanceView from './NoSessionsAttendanceView';
import { AttendanceContext } from '../../context/AttendanceContext';

const Container = styled.div`
    padding: 1rem;
`;

const AttendanceView = () => {
    const { loading, error, sessions, progress } = useContext(AttendanceContext);

    if (loading && progress) {
        return <AttendanceProgress />;
    }

    if (loading) {
        return <AttendanceLoading />;
    }

    if (error) {
        return <AttendanceError />;
    }

    if (sessions.length < 1) {
        return <NoSessionsAttendanceView />;
    }

    return (
        <div>
            <Container>
                <AttendanceSelect />
            </Container>
            <AttendanceOverview />
        </div>
    );
};

export default AttendanceView;
